import {Suspense} from 'react';
import {lazyWithRetry} from 'src/utils/lazyWithRetry';
import {Navigate, Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'
import {sellerRegistryRouteDecision} from 'src/pages/sellers/sellerRegistryAccess'

const SellersPage = lazyWithRetry(() => import('src/pages/sellers/SellersPage'));
const SellerRegistryViewPage = lazyWithRetry(() => import('src/pages/sellers/SellerRegistryViewPage'));

function SellerRegistryRoute() {
  const decision = useSelector(sellerRegistryRouteDecision)

  if (decision === 'loading') return <LoadingScreen />
  if (decision === 'redirect') {
    return <Navigate to="/sellers" replace />
  }
  return <SellerRegistryViewPage />
}

export const sellersRoutes = [
  {
    path: '/sellers',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <SellersPage />,
      },
      {
        path: 'registry/:registryId/:sellerId',
        element: <SellerRegistryRoute />,
      },
      {
        path: 'registry/:registryId',
        element: <SellerRegistryRoute />,
      },
      {
        path: ':sellerId',
        element: <SellersPage />,
      },
      {
        path: ':sellerId/operations/edit/:id',
        element: <SellersPage />,
      },
      {
        path: ':sellerId/operations/view/:id',
        element: <SellersPage />,
      },
    ],
  },
];
